export default () => ({
  password: '',
  confirmPassword: ''
});
